import { Pipe, PipeTransform } from '@angular/core';
import { CategoriesProvider, CategoryModel } from '../../providers/categories/categories';

/**
 * Generated class for the IconPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'icon'
})
export class IconPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  constructor(private categoryService: CategoriesProvider) { }
  storedCategory: CategoryModel;
  async transform(value: string, ...args) {
    let category;
    // bit faster if request the same category x times in a row
    if (this.storedCategory && this.storedCategory.id === parseInt(value)) {
      category = this.storedCategory;
    } else {
      let categories = await this.categoryService.getAllCategories();
      category = categories.find(x => x.id === parseInt(value));
      this.storedCategory = category;
    }
    let name;
    if (category) {
      name = category.uniqueName.toLowerCase().replace('category_', '');
    } else {
      name = '';
    }
    let pre;

    if (args.find(x => x === 'marker')) {
      pre = 'marker';
    } else {
      pre = 'icon';
    }
    if (this.icons[pre + '_' + name]) {
      return this.icons[pre + '_' + name];
    } else {
      return this.icons[pre + '_'];
    }
  }

  get(prefix: string, name: string) {
    let full = prefix + '_' + name;
    if (this.icons[full]) {
      return this.icons[full];
    } else {
      full = prefix + '_';
      if (this.icons[full]) {
        return this.icons[full];
      } else {
        return this.icons['icon_'];
      }
    }
  }

  icons = {
    icon_crossduathlon: 'assets/imgs/sportart_svg/rennrad.svg',
    icon_duathlon: 'assets/imgs/sportart_svg/duathlon.svg',
    icon_inline: 'assets/imgs/sportart_svg/inlineskating.svg',
    icon_run: 'assets/imgs/sportart_svg/laufen.svg',
    icon_frauenrun: 'assets/imgs/sportart_svg/laufen.svg',
    icon_crossrun: 'assets/imgs/sportart_svg/laufen.svg',
    icon_lauftreff: 'assets/imgs/sportart_svg/laufen.svg',
    icon_hindernisrun: 'assets/imgs/sportart_svg/huerdenlauf.svg',
    icon_mtb: 'assets/imgs/sportart_svg/mtb.svg',
    icon_roadbike: 'assets/imgs/sportart_svg/rennrad.svg',
    icon_swim: 'assets/imgs/sportart_svg/schwimmen.svg',
    icon_tri: 'assets/imgs/sportart_svg/triathlon.svg',
    icon_skiLanglauf: 'assets/imgs/sportart_svg/skilanglauf.svg',
    icon_walking: 'assets/imgs/sportart_svg/walking.svg',
    icon_kraftsport: 'assets/imgs/sportart_svg/kraftsport.svg',
    icon_rollstuhl: 'assets/imgs/sportart_svg/rollstuhl.svg',
    icon_: 'assets/imgs/sportart_svg/laufen.svg', // default for empty uniqueName fe: Alle

    iconW_CrossDuathlon: 'assets/imgs/sportart_white/rennrad.svg',
    iconW_Duathlon: 'assets/imgs/sportart_white/duathlon.svg',
    iconW_Inline: 'assets/imgs/sportart_white/inlineskating.svg',
    iconW_Run: 'assets/imgs/sportart_white/laufen.svg',
    iconW_FrauenRun: 'assets/imgs/sportart_white/laufen.svg',
    iconW_CrossRun: 'assets/imgs/sportart_white/laufen.svg',
    iconW_Lauftreff: 'assets/imgs/sportart_white/laufen.svg',
    iconW_HindernisRun: 'assets/imgs/sportart_white/huerdenlauf.svg',
    iconW_Mtb: 'assets/imgs/sportart_white/mtb.svg',
    iconW_RoadBike: 'assets/imgs/sportart_white/rennrad.svg',
    iconW_Swim: 'assets/imgs/sportart_white/schwimmen.svg',
    iconW_Tri: 'assets/imgs/sportart_white/triathlon.svg',
    iconW_SkiLanglauf: 'assets/imgs/sportart_white/skilanglauf.svg',
    iconW_Walking: 'assets/imgs/sportart_white/walking.svg',
    iconW_Kraftsport: 'assets/imgs/sportart_white/kraftsport.svg',
    iconW_Rollstuhl: 'assets/imgs/sportart_white/rollstuhl.svg',
    iconW_: 'assets/imgs/sportart_white/laufen.svg',
    markergo_: 'assets/imgs/marker/laufen-logo.png',
    marker_: 'assets/imgs/marker/laufen.png',
    marker_parking: 'assets/imgs/marker/parking.png',
    marker_coffee: 'assets/imgs/marker/coffee.png',
    marker_info: 'assets/imgs/marker/info.png',
    marker_finish: 'assets/imgs/marker/ziel.png',
    marker_me: 'assets/imgs/marker/pulsing_marker.gif',

    marker: 'assets/imgs/marker/138.png',
    marker_laufen: 'assets/imgs/marker/138.png',
    marker_crossrun: 'assets/imgs/marker/138.png',
    marker_hindernisrun: 'assets/imgs/marker/138.png',
    marker_crossduathlon: 'assets/imgs/marker/136.png',
    marker_inline: 'assets/imgs/marker/137.png',
    marker_mtb: 'assets/imgs/marker/139.png',
    marker_roadbike: 'assets/imgs/marker/140.png',
    marker_swim: 'assets/imgs/marker/141.png',
    marker_skilanglauf: 'assets/imgs/marker/skilanglauf.png',
    marker_tri: 'assets/imgs/marker/142.png',
    marker_walking: 'assets/imgs/marker/walking.png',
    marker_first: 'assets/imgs/marker/first.png',
    marker_last: 'assets/imgs/marker/last.png'
  };
}



// WEBPACK FOOTER //
// /src/pipes/icon/icon.ts